// Unpublished Work © 2025 Deere & Company.

function reduceIsgToggles(isgToggles, isgToggle) {
    isgToggles[isgToggle.name] = true;

    return isgToggles;
}

export {
    reduceIsgToggles
};
